<div class="setting">
  <div class="level">

    <img loading="lazy" [src]="profileImage" class="rounded" />

    <div class="info">
      <u style="cursor: pointer;" [routerLink]="['/profile', profileInfo?.referralCode]">{{
        profileInfo?.profileCharacterName }}</u> (Lvl {{ profileInfo?.level ?? 1 }})
    </div>
    <div class="phone">
      {{ maskNumber(profileInfo?.phone) || "" }}
    </div>
  </div>
  <ul>
    <li>
      <a [routerLink]="['/me/profile']">
        <i class="fa-solid fa-user-circle"></i>
        <div class="right">
          <span class="text">Dashboard</span>
        </div>
      </a>
    </li>
    <li>
      <a (click)="GoToMyTabs(4)">
        <i class="fa-solid fa-gear"></i>
        <div class="right">
          <span class="text">Profile Settings</span>
        </div>
      </a>
    </li>
    <li *ngIf="roleService.roles?.level.includes('MEMBER_PROFILE_AVATAR')">
      <a (click)="GoToMyTabs(1)">
        <i class="fa-solid fa-user-astronaut"></i>
        <div class="right">
          <span class="text">Avatar</span>
        </div>
      </a>
    </li>

    <li>
      <a>
        <i class="fa-solid fa-clipboard-check"></i>
        <div class="right">
          <span class="text">Points</span>
          <span class="badge badge-warning">
            {{ profileInfo?.points || 0 }}
          </span>
          <span (click)="showOtherMenu = !showOtherMenu" class="pl-2">
            <i class="fa-solid fa-chevron-{{ showOtherMenu ? 'up' : 'down' }}"></i>
          </span>
          <ngb-progressbar [animated]="true" type="success" [value]="profileInfo?.progressBarValue || 0"
            [striped]="true"></ngb-progressbar>
        </div>
      </a>
    </li>
    <ng-container *ngIf="showOtherMenu">
      <li>
        <a>
          <i class="fa-solid fa-clipboard-list"></i>
          <div class="right">
            <span class="text">Forum Posts</span>
            <span class="badge badge-warning">
              {{ profileInfo?.forumPostsCount || 0 }}
            </span>
          </div>
        </a>
      </li>
      <li>
        <a>
          <i class="fa-solid fa-pen-square"></i>
          <div class="right">
            <span class="text">Suggestions</span>
            <span class="badge badge-warning">
              {{ profileInfo?.suggestionsCount || 0 }}
            </span>
          </div>
        </a>
      </li>
      <li>
        <a>
          <i class="fa-solid fa-user"></i>
          <div class="right">
            <span class="text">Referrals</span>
            <span class="badge badge-warning">
              {{ profileInfo?.referralsCount || 0 }}
            </span>
          </div>
        </a>
      </li>
      <li>
        <!-- (click)="openProfilePopupFavoriteProduct($event, favoriteModal)" -->
        <a>
          <i class="fa-solid fa-heart"></i>
          <div class="right">
            <span class="text">Favorite Products</span>
            <span class="badge badge-warning">
              {{ profileInfo?.favoritesCount || 0 }}
            </span>
          </div>
        </a>
      </li>
    </ng-container>
  </ul>
  <div class="bottom-info">
    <div class="bottom-info__verified"
      style="display: flex; justify-content: flex-start; flex-direction: column; align-items: flex-start;">

      <small class="bottom-info__diamonds" (click)="openBuyDiamonds()">
        <img loading="lazy" src="../../../../../../assets/images/diamond.png"
          style="height: 1.25em; margin-right: 0.1em" />
        {{ diamonds }}
      </small>
    </div>
  </div>



  <div class="verification" *ngIf="showVerification" [ngClass]="{ active: showVerification }">
    <span (click)="showVerification = false; isReset = false">
      <i class="fa-solid fa-times" style="color: black !important"></i>
    </span>
    <div>
      <div style="display: flex; justify-content: center; align-items: center;">
        <mat-label>Enter OTP</mat-label>
        <mat-form-field style="width: 100%; display: flex; align-items: center; gap: 10px">
          <input matInput formControlName="otp" maxlength="6" style="text-align: center" class="form-control"
            (change)="onChangeOtp($event)" required />
          <button mat-raised-button color="primary" (click)="sendOtp()" [disabled]="isLoading"
            style="margin-bottom: 10px" class="btn btn-purple">OTP</button>
        </mat-form-field>
      </div>

      <mat-form-field style="width: 100%; display: flex; flex-direction: column">
        <mat-label class="mb-2 mt-2">Enter 4 Digit Passcode</mat-label>
        <input matInput formControlName="otp" maxlength="4" style="text-align: center" class="form-control mb-2"
          (change)="onChangePasscode($event)" required />
      </mat-form-field>
      <div style="color: red">{{ otpError }}</div>
      <button (click)="verifyOtp()" [disabled]="isLoading" class="btn btn-purple mt-2">Verify</button>
    </div>
  </div>